import { render, staticRenderFns } from "./CategoryEditButton.vue?vue&type=template&id=c2baf278&scoped=true&"
import script from "./CategoryEditButton.vue?vue&type=script&lang=js&"
export * from "./CategoryEditButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEditButton.vue?vue&type=style&index=0&id=c2baf278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2baf278",
  null
  
)

component.options.__file = "CategoryEditButton.vue"
export default component.exports